import api from '../api';

const baseUrl = (token) => `utilities/${token}`;

export const getCountries = (token) =>
  api({
    method: 'get',
    url: `${baseUrl(token)}/countries`
  });

export const getGenders = (token) =>
  api({
    method: 'get',
    url: `${baseUrl(token)}/genders`
  });

export const getLanguages = (token) =>
  api({
    method: 'get',
    url: `${baseUrl(token)}/languages`
  });
